import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import ButtonWithTitle from './buttons/ButtonWithTitle';

interface Props {
    onAnswer: () => void;
    onHangup: () => void;
    onDecline: () => void;
    onHold: () => void;
    onResume: () => void;
    onTransferStart: () => void;
    onTransferComplete?: () => void;
    onTransferCancel?: () => void;
    onMerge: () => void;
    useOmnichannelLook: boolean;
    conferenceToMeeting?: () => void;
}

const ButtonContainer = ({
    onAnswer,
    onHangup,
    onDecline,
    onHold,
    onResume,
    onTransferStart,
    onTransferComplete,
    onTransferCancel,
    onMerge,
    useOmnichannelLook,
    conferenceToMeeting,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="my-3 flex h-16 flex-auto items-stretch justify-center gap-x-7">
            {onHangup && (
                <ButtonWithTitle
                    onClick={onHangup}
                    iconKey={'call_end'}
                    className="bg-red"
                    dataTestId="hangup-button"
                    buttonTitle={i18next.t('Call.Canvas.Title.HangUp')}
                />
            )}

            {onDecline && (
                <ButtonWithTitle
                    onClick={onDecline}
                    iconKey="call_end"
                    className="bg-red"
                    buttonTitle={i18next.t('Call.Canvas.Title.Dismiss')}
                />
            )}

            {onAnswer && (
                <ButtonWithTitle
                    onClick={onAnswer}
                    buttonTitle={i18next.t('Call.Canvas.Title.Answer')}
                    dataTestId="answer-button"
                    iconKey={useOmnichannelLook ? 'email' : 'call'}
                    className={useOmnichannelLook ? 'bg-link' : 'bg-green'}
                />
            )}

            {onHold && (
                <ButtonWithTitle
                    onClick={onHold}
                    buttonTitle={i18next.t('Call.Canvas.Title.Park')}
                    dataTestId="hold-button"
                    iconKey="pause"
                />
            )}

            {onResume && (
                <ButtonWithTitle
                    onClick={onResume}
                    buttonTitle={i18next.t('Call.Canvas.Title.Unpark')}
                    iconKey="play_arrow"
                    dataTestId="resume-button"
                />
            )}

            {onTransferStart && (
                <ButtonWithTitle
                    onClick={onTransferStart}
                    iconKey="transfer_call"
                    buttonTitle={i18next.t('Call.Canvas.Title.TransferStart')}
                />
            )}

            {onTransferCancel && (
                <ButtonWithTitle
                    onClick={onTransferCancel}
                    iconKey="call_end"
                    buttonTitle={i18next.t('cancel')}
                />
            )}

            {onTransferComplete && (
                <ButtonWithTitle
                    onClick={onTransferComplete}
                    iconKey="transfer_call"
                    buttonTitle={i18next.t(
                        'Call.Canvas.Title.TransferComplete',
                    )}
                />
            )}

            {onMerge && (
                <ButtonWithTitle
                    onClick={onMerge}
                    iconKey="merge_call"
                    buttonTitle={i18next.t('call.merge')}
                    dataTestId="merge-button"
                />
            )}

            {conferenceToMeeting && (
                <ButtonWithTitle
                    onClick={conferenceToMeeting}
                    iconKey="video"
                    buttonTitle={i18next.t('Call.Canvas.Title.Video')}
                    tooltipLabel={i18next.t(
                        'Call.Canvas.Title.Rejoin_With_Video',
                    )}
                />
            )}
        </div>
    );
};

export default ButtonContainer;
